import Vue from 'vue';
import VueRouter from 'vue-router';
import VueHead from 'vue-head';

Vue.use(VueHead);
Vue.use(VueRouter);

export const dynamicHead = {
  data() {
    return {
      metaParams: {
        title: '',
        description: '',
        image: '',
        schema: null
      },
      exportData: [],
      list: []
    };
  },
  head: function () {
    return {
      title: () => {
        return {
          inner:
            this.metaParams.title && this.metaParams.title.length
              ? this._unescapeHtml(this.metaParams.title)
              : 'Renew – Профессиональная косметика для салонного ухода – Компания”Ренью – Украина” это официальное представительство израильской профессиональной космецевтики Renew для салонного ухода.',
          separator: ' ',
          complement: ' '
        };
      },
      meta: () => {
        let prerenderStatusCode = document.querySelector(`meta[name="prerender-status-code"]`);
        if (prerenderStatusCode) prerenderStatusCode.remove();

        let { fullPath } = this.$route;
        let { title, description, image, schema, prerender } = this.metaParams;
        let locale = fullPath.slice(1, 4) === 'ua/' ? 'uk_UA' : 'ru_RU';
        image = image || '/preview.png';

        let metaCollection = [
          { p: 'og:image', content: image, id: 'og:image' },
          { p: 'og:url', content: window.location.origin + this.$route.path, id: 'og:url' },
          { p: 'og:locale', content: locale, id: 'og:locale' },
          { p: 'twitter:image', content: image, id: 'twitter:image' }
        ];
        if (title) {
          metaCollection = [
            ...metaCollection,
            { p: 'og:title', content: title, id: 'og:title' },
            { p: 'twitter:title', content: title, id: 'twitter:title' },
            { n: 'title', content: title, id: 'title' }
          ];
        }

        if (description) {
          description = this._stripHtml(description);
          metaCollection = [
            ...metaCollection,
            { p: 'og:description', content: description, id: 'og:description' },
            { p: 'twitter:description', content: description, id: 'twitter:description' },
            { n: 'description', content: description, id: 'description' }
          ];
        }

        if (prerender) {
          metaCollection = [
            ...metaCollection,
            { n: 'prerender-status-code', content: prerender?.content || '', id: 'prerender-status-code' }
          ];
        }

        return metaCollection;
      },
      link: () => {
        let oldCanonical = document.querySelector(`link[rel="canonical"][href="${process.env.VUE_APP_URL}"]`);
        if (oldCanonical) oldCanonical.remove();

        let defaultPath = this.$route.path;
        let canonicalHref = window.location.origin + this.$route.path;
        let shortlinkHref = canonicalHref;
        if (defaultPath.slice(1, 4) === 'ua/') {
          defaultPath = defaultPath.slice(3);
        }
        return [
          { rel: 'canonical', href: canonicalHref, id: 'canonical' },
          { rel: 'shortlink', href: shortlinkHref, id: 'shortlink' },
          { rel: 'alternate', hreflang: 'x-default', href: window.location.origin + defaultPath, id: 'x-default' },
          { rel: 'alternate', hreflang: 'ru-ru', href: window.location.origin + defaultPath, id: 'ru' },
          { rel: 'alternate', hreflang: 'uk-ua', href: window.location.origin + '/ua' + defaultPath, id: 'ua' }
        ];
      },
      script: () => {
        let org = {
          '@context': 'http://schema.org',
          '@type': 'Organization',
          name: 'Renew',
          url: 'https://renew.net.ua/',
          logo: 'https://renew.net.ua/logo.png',
          // foundingDate: '2015',
          contactPoint: [
            { '@type': 'ContactPoint', email: 'office@renew.net.ua', contactType: 'Sales' },
            {
              '@type': 'ContactPoint',
              telephone: '+38(095) 011 30 70',
              contactType: 'Customer Support'
            },
            {
              '@type': 'ContactPoint',
              telephone: '+38(067) 411 30 70',
              contactType: 'Customer Support'
            }
          ],
          sameAs: []
        };
        this.exportData.push({ id: 'organization', t: 'application/ld+json', i: JSON.stringify(org) });
        return this.exportData;
      }
    };
  },
  watch: {
    $route() {
      this.setMeta();
    }
  },
  methods: {
    _unescapeHtml(data) {
      const textArea = document.createElement('textarea');
      textArea.innerHTML = data;
      return textArea.value;
    },
    _stripHtml(html) {
      let div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent
        .replace(/\u00A0/g, ' ')
        .replace(/\s+\n/g, '\n')
        .trim();
    },
    setMeta() {
      this.$emit('updateHead');
    },
    setCatalogSchema() {
      this.exportData.push({ id: 'ItemList', t: 'application/ld+json', i: this.metaParams.schema });
      this.$emit('updateHead');
    },
    setProductSchema() {
      this.exportData.push({ id: 'Product', t: 'application/ld+json', i: this.metaParams.schema });
      this.$emit('updateHead');
    }
  }
};
